import React from 'react'

import Email, { EmailProps } from './Email'

import { EMAIL_FILE_EXTENSION } from '@SonarCX/slices/extensionAPI'

type EmailSectionProps = EmailProps & {
  values: LocalTask
}

const EmailSection: React.FC<EmailSectionProps> = ({ values, ...props }) => {
  const media = React.useMemo(() => values.media || [], [values])

  const emails = React.useMemo(
    () => media.filter(m => m.filename.endsWith(EMAIL_FILE_EXTENSION)),
    [media]
  )

  if (emails.length === 0) {
    return <div>No emails</div>
  }

  return (
    <>
      {emails.map(email => (
        <Email key={email.id} email={email} {...props} />
      ))}
    </>
  )
}

export default EmailSection
